// extracted by mini-css-extract-plugin
module.exports = {"title":"title-235BHs7x","list":"list-1sWpsqfN","red":"red-HhxHXdy1","black":"black-2cQncyiQ"};